// extracted by mini-css-extract-plugin
module.exports = {"container":"PageHeader_container__ZWd_7","root":"PageHeader_root__Fp9_7","container--grid":"PageHeader_container--grid__NQw1e"};